import React from "react";
import { SyncOutlined } from "@ant-design/icons";
import { useThemeMode } from "../../contexts/ThemeContext";

/**
 * Bottom-right toast shown while product changes (e.g. COGS) sync in the background.
 */
const ProductSyncToast = ({ visible }) => {
    const { themeMode } = useThemeMode();
    const isDark = themeMode === "dark";

    if (!visible) return null;

    return (
        <div
            style={{
                position: "fixed",
                bottom: "24px",
                right: "24px",
                zIndex: 1051,
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
                background: "var(--app-surface)",
                border: "1px solid var(--app-border)",
                borderLeft: "4px solid #f45b68",
                borderRadius: "10px",
                padding: "14px 16px",
                boxShadow: isDark ? "0 6px 24px rgba(0,0,0,0.45)" : "0 6px 24px rgba(0,0,0,0.10)",
                minWidth: "280px",
                maxWidth: "340px",
                animation: "slideInProductSyncToast 0.3s ease",
            }}
        >
            <div style={{ marginTop: "2px", flexShrink: 0 }}>
                <SyncOutlined spin style={{ fontSize: "18px", color: "#f45b68" }} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: "13px", color: "var(--app-text)", marginBottom: "3px" }}>
                    Syncing product changes
                </div>
                <div style={{ fontSize: "12px", color: "var(--app-text-muted)", lineHeight: "1.4" }}>
                    Updating your P&L metrics in the background. You can keep browsing while this finishes.
                </div>
            </div>
            <style>{`
                @keyframes slideInProductSyncToast {
                    from { opacity: 0; transform: translateY(16px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

export default ProductSyncToast;
